<script>
  import {
    makeEscapeAction,
    makeWindowClick,
  } from "@sourcewhale/shared/src/svelte/utils/escapable";
  import InteractiveStatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/InteractiveStatusTag.svelte";
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import FloatingUI from "@sourcewhale/shared/svelte-design-system/components/utils/FloatingUI.svelte";

  export let count;

  let el;
  let floatingEl;
  let show = false;

  const toggleOverflow = (e) => {
    el = e ? e.currentTarget : null;
    show = !show;
  };

  const escape = makeEscapeAction(toggleOverflow);
  $: windowClick = makeWindowClick(toggleOverflow, el, floatingEl);

  // Change tooltip when floating ui opens
  $: tooltipText = show ? "Show less" : "Show more";

  // show should never be true if count is 0.
  // This prevents an error if the FloatingUI is open and the modal view changes
  // or if the modal size is changed while the FloatingUI is open and count becomes 0.
  $: show = show && count > 0;
</script>

<svelte:window on:click={windowClick} />

{#if count}
  <Tooltip placement="bottom" let:dismiss>
    <span slot="tooltip">{tooltipText}</span>
    <InteractiveStatusTag
      size="medium"
      onclick={(e) => {
        dismiss(e);
        toggleOverflow(e);
      }}
      {...$$restProps}
    >
      +{count}
    </InteractiveStatusTag>
  </Tooltip>
  {#if show}
    <FloatingUI
      referenceEl={el}
      bind:floatingEl
      class="z-index-1"
      placement="right"
      {escape}
    >
      <slot name="hidden-items" />
    </FloatingUI>
  {/if}
{/if}
